/* POSTS AJAX */
$(function(){

	/*
	 * Load More
	 */
	$('#posts_loadmore').click(function(event){

        event.preventDefault();
        // console.log('loadmore');

		$.ajax({
			url : news_loadmore_params.ajaxurl, // AJAX handler
			data : {
				'action': 'postloadmore', // the parameter for admin-ajax.php
				'query': news_loadmore_params.posts, // loop parameters passed by wp_localize_script()
				'page' : news_loadmore_params.current_page // current page
			},
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#posts_loadmore').text('Loading...'); // some type of preloader
			},
			success : function( posts ){
				if( posts ) {

                    // $('.postpage__wrapper').empty();
					$('#posts_loadmore').text( 'Load More' );
					$('#postpage__results .row').append( posts ); // insert new posts
					news_loadmore_params.current_page++;

					if ( news_loadmore_params.current_page == news_loadmore_params.max_page ){
                        $('.postpage__loadmore').hide(); // if last page, HIDE the button
                    }

				} else {
					$('.postpage__loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	/*
	 * Filter
	 */
	$('#filter_posts').submit(function(event){

        event.preventDefault();
        // console.log('filter');

		$.ajax({
			url : news_loadmore_params.ajaxurl,
			data : $('#filter_posts').serialize(), // form data
			dataType : 'json', // this data type allows us to receive objects from the server
			type : 'POST',
			beforeSend : function(xhr){
				// $('#filter_posts').find('button').text('Filtering...');
			},
			success : function( data ){

                // console.log(data);

                $('.postpage__wrapper').empty();

				// when filter applied:
				// set the current page to 1
				news_loadmore_params.current_page = 1;

				// set the new query parameters
				news_loadmore_params.posts = data.posts;

				// set the new max page parameter
				news_loadmore_params.max_page = data.max_page;

				// change the button label back
				// $('#filter_posts').find('button').text('Apply filter');

				// insert the posts to the container
				// $('#postpage__results .row').html(data.content);
                $('#postpage__results .row').html(data.content);

                // console.log(data.content);
                // console.log(data);

				// hide load more button, if there are not enough posts for the second page
				if ( data.max_page < 2 ) {
					$('.postpage__loadmore').hide();
				} else {
					$('.postpage__loadmore').show();
				}
			}
		});

		// do not submit the form
		return false;

	});

});
/* POSTS AJAX */


/* EVENTS AJAX */
$(function(){

	/*
	 * Load More
	 */
	$('#events_loadmore').click(function(event){

        event.preventDefault();
        console.log('loadmore');

		$.ajax({
			url : events_loadmore_params.ajaxurl, // AJAX handler
			data : {
				'action': 'eventsloadmore', // the parameter for admin-ajax.php
				'query': events_loadmore_params.posts, // loop parameters passed by wp_localize_script()
				'page' : events_loadmore_params.current_page // current page
			},
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#events_loadmore').text('Loading...'); // some type of preloader
			},
			success : function( posts ){
				if( posts ) {

                    // console.log(posts);

                    // $('.postpage__wrapper').empty();
					$('#events_loadmore').text( 'Load More' );
					$('#postpage__results .row').append( posts ); // insert new posts
					events_loadmore_params.current_page++;

					if ( events_loadmore_params.current_page == events_loadmore_params.max_page ){
                        $('.postpage__loadmore').hide(); // if last page, HIDE the button
                    }

				} else {
					$('.postpage__loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	/*
	 * Filter
	 */
	$('#filter_events').submit(function(event){

        event.preventDefault();
        // console.log('filter');

		$.ajax({
			url : events_loadmore_params.ajaxurl,
			data : $('#filter_events').serialize(), // form data
			dataType : 'json', // this data type allows us to receive objects from the server
			type : 'POST',
			beforeSend : function(xhr){
				// $('#filter_events').find('button').text('Filtering...');
			},
			success : function( data ){

                // console.log(data);

                $('.postpage__wrapper').empty();

				// when filter applied:
				// set the current page to 1
				events_loadmore_params.current_page = 1;

				// set the new query parameters
				events_loadmore_params.posts = data.posts;

				// set the new max page parameter
				events_loadmore_params.max_page = data.max_page;

				// change the button label back
				// $('#filter_events').find('button').text('Apply filter');

				// insert the posts to the container
				// $('#postpage__results .row').html(data.content);
                $('#postpage__results .row').html(data.content);

                // console.log(data.content);
                // console.log(data);

				// hide load more button, if there are not enough posts for the second page
				if ( data.max_page < 2 ) {
					$('.postpage__loadmore').hide();
				} else {
					$('.postpage__loadmore').show();
				}
			}
		});

		// do not submit the form
		return false;

	});

});
/* EVENTS AJAX */


/* VACANCIES AJAX */
$(function(){

	/*
	 * Load More
	 */
	$('#vacancies_loadmore').click(function(event){

        event.preventDefault();
        // console.log('loadmore');

		$.ajax({
			url : vacancies_loadmore_params.ajaxurl, // AJAX handler
			data : {
				'action': 'vacanciesloadmore', // the parameter for admin-ajax.php
				'query': vacancies_loadmore_params.posts, // loop parameters passed by wp_localize_script()
				'page' : vacancies_loadmore_params.current_page // current page
			},
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#vacancies_loadmore').text('Loading...'); // some type of preloader
			},
			success : function( posts ){
				if( posts ) {


                    // console.log(posts);

                    // $('.postpage__wrapper').empty();
					$('#vacancies_loadmore').text( 'More Vacancies' );
					$('#postpage__results .row').append( posts ); // insert new posts
					vacancies_loadmore_params.current_page++;

					if ( vacancies_loadmore_params.current_page == vacancies_loadmore_params.max_page ){
                        $('.postpage__loadmore').hide(); // if last page, HIDE the button
                    }

				} else {
					$('.postpage__loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	/*
	 * Filter
	 */
	$('#filter_vacancies').submit(function(event){

        event.preventDefault();
        console.log('filter');

		$.ajax({
			url : vacancies_loadmore_params.ajaxurl,
			data : $('#filter_vacancies').serialize(), // form data
			dataType : 'json', // this data type allows us to receive objects from the server
			type : 'POST',
			beforeSend : function(xhr){
				// $('#filter_vacancies').find('button').text('Filtering...');
			},
			success : function( data ){

                console.log(data.content);

                $('.postpage__wrapper').empty();

				// when filter applied:
				// set the current page to 1
				vacancies_loadmore_params.current_page = 1;

				// set the new query parameters
				vacancies_loadmore_params.posts = data.posts;

				// set the new max page parameter
				vacancies_loadmore_params.max_page = data.max_page;

				// change the button label back
				// $('#filter_vacancies').find('button').text('Apply filter');

				// insert the posts to the container
				$('#postpage__results .row').html(data.content);
                // $('#postpage__results).html(data.content);

                // console.log(data.content);
                // console.log(data);

				// hide load more button, if there are not enough posts for the second page
				if ( data.max_page < 2 ) {
					$('.postpage__loadmore').hide();
				} else {
					$('.postpage__loadmore').show();
				}
			}
		});

		// do not submit the form
		return false;

	});

});
/* VACANCIES AJAX */


/* DIRECTORY AJAX */
$(function(){

	/*
	 * Load More
	 */
	$('#directory_loadmore').click(function(event){

        event.preventDefault();
        // console.log('loadmore');

		$.ajax({
			url : directory_loadmore_params.ajaxurl, // AJAX handler
			data : {
				'action': 'directoryloadmore', // the parameter for admin-ajax.php
				'query': directory_loadmore_params.posts, // loop parameters passed by wp_localize_script()
				'page' : directory_loadmore_params.current_page // current page
			},
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#directory_loadmore').text('Loading...'); // some type of preloader
			},
			success : function( posts ){
				if( posts ) {


                    // console.log(posts);

                    // $('.postpage__wrapper').empty();
					$('#directory_loadmore').text( 'More Companies' );
					$('#postpage__results .row').append( posts ); // insert new posts
					directory_loadmore_params.current_page++;

					if ( directory_loadmore_params.current_page == directory_loadmore_params.max_page ){
                        $('.postpage__loadmore').hide(); // if last page, HIDE the button
                    }

				} else {
					$('.postpage__loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	/*
	 * Filter
	 */
	$('#filter_directory').submit(function(event){

        event.preventDefault();
        console.log('filter');

		$.ajax({
			url : directory_loadmore_params.ajaxurl,
			data : $('#filter_directory').serialize(), // form data
			dataType : 'json', // this data type allows us to receive objects from the server
			type : 'POST',
			beforeSend : function(xhr){
				// $('#filter_directory').find('button').text('Filtering...');
			},
			success : function( data ){

                console.log(data.content);

                $('.postpage__wrapper').empty();

				// when filter applied:
				// set the current page to 1
				directory_loadmore_params.current_page = 1;

				// set the new query parameters
				directory_loadmore_params.posts = data.posts;

				// set the new max page parameter
				directory_loadmore_params.max_page = data.max_page;

				// change the button label back
				// $('#filter_vacancies').find('button').text('Apply filter');

				// insert the posts to the container
				$('#postpage__results .row').html(data.content);
                // $('#postpage__results).html(data.content);

                // console.log(data.content);
                // console.log(data);

				// hide load more button, if there are not enough posts for the second page
				if ( data.max_page < 2 ) {
					$('.postpage__loadmore').hide();
				} else {
					$('.postpage__loadmore').show();
				}
			}
		});

		// do not submit the form
		return false;

	});

});
/* DIRECTORY AJAX */
